import {HttpHandler} from "../../../utils/handler/HttpHandler";
import {downloadFileNewArch} from "../../../utils/file/download";

export class BilateralReportService {
    constructor() {
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/report');
    }

    getControlPanelReport(type, params) {
        return downloadFileNewArch(this.axiosInstance, '/' + type, params);
    }
}